import { render, staticRenderFns } from "./SupplierOrderProgress.vue?vue&type=template&id=5f740061&"
import script from "./SupplierOrderProgress.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports